import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

function TermsPage() {
    const { t } = useTranslation();

    return (
        <>
        <SEO
            title="Terms & Conditions"
            description="Terms and conditions for using Career Platform's AI-powered career tools and services."
            path="/terms"
        />
        <div className="auth-container" style={{ alignItems: 'flex-start', padding: '2rem' }}>
            <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '2.5rem',
                maxWidth: '700px',
                width: '100%',
                margin: '0 auto',
                boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
            }}>
                <h1 style={{ color: '#1e293b', marginBottom: '0.5rem' }}>{t('terms.title')}</h1>
                <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginBottom: '2rem' }}>
                    {t('terms.last_updated')}
                </p>

                {[
                    {
                        title: t('terms.sections.acceptance.title'),
                        body: t('terms.sections.acceptance.body'),
                    },
                    {
                        title: t('terms.sections.service.title'),
                        body: t('terms.sections.service.body'),
                    },
                    {
                        title: t('terms.sections.accounts.title'),
                        body: t('terms.sections.accounts.body'),
                    },
                    {
                        title: t('terms.sections.payments.title'),
                        body: t('terms.sections.payments.body'),
                    },
                    {
                        title: t('terms.sections.privacy.title'),
                        body: t('terms.sections.privacy.body'),
                    },
                    {
                        title: t('terms.sections.content.title'),
                        body: t('terms.sections.content.body'),
                    },
                    {
                        title: t('terms.sections.use.title'),
                        body: t('terms.sections.use.body'),
                    },
                    {
                        title: t('terms.sections.ai.title'),
                        body: t('terms.sections.ai.body'),
                    },
                    {
                        title: t('terms.sections.availability.title'),
                        body: t('terms.sections.availability.body'),
                    },
                    {
                        title: t('terms.sections.changes.title'),
                        body: t('terms.sections.changes.body'),
                    },
                    {
                        title: t('terms.sections.contact.title'),
                        body: t('terms.sections.contact.body'),
                    },
                ].map(section => (
                    <div key={section.title} style={{ marginBottom: '1.5rem' }}>
                        <h3 style={{ fontSize: '0.95rem', fontWeight: '700', color: '#1e293b', marginBottom: '0.5rem' }}>
                            {section.title}
                        </h3>
                        <p style={{ fontSize: '0.875rem', color: '#475569', lineHeight: '1.7' }}>
                            {section.body}
                        </p>
                    </div>
                ))}

                <div style={{ marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid #e8ecf0', textAlign: 'center' }}>
                    <Link
                        to="/register"
                        style={{
                            background: '#3b82f6',
                            color: 'white',
                            padding: '0.75rem 2rem',
                            borderRadius: '8px',
                            textDecoration: 'none',
                            fontWeight: '600',
                            fontSize: '0.95rem',
                        }}
                    >
                        {t('terms.back_register')}
                    </Link>
                </div>
            </div>
        </div>
        </>
    );
}

export default TermsPage;